export const myToysPage = {
    'my.toys.page.title': 'Мои игрушки',
    'my.toys.page.toy.for.sale.modal.title': 'Игрушка на продажу',
}
